import { escrowOfficerCard, withTaxIdBesideYearBuilt } from '../../shared';
import type { ListingLocaleOverrides } from '../base';

export const WAOverrides: ListingLocaleOverrides = {
  locale: 'WA',
  sections: {
    propertyInfo: {
      cards: {
        propertyBeingSoldCard: {
          layout: (layout) =>
            withTaxIdBesideYearBuilt(layout).concat([
              [
                {
                  name: 'property.legalDescription',
                  size: 100,
                },
              ],
            ]),
          fields: {
            taxIdNumber: {
              name: 'property.taxIdNumber',
              entity: 'property',
              type: 'text',
              label: 'Property Tax ID Number',
              placeholderText: '',
            },
            legalDescription: {
              name: 'property.legalDescription',
              entity: 'property',
              type: 'textarea',
              label: 'Legal Description',
              placeholderText: '',
            },
          },
        },
      },
    },
    additionalContacts: {
      cards: {
        escrow: {
          ...escrowOfficerCard,
          order: -1,
        },
      },
    },
  },
};
